import React from 'react';
import styles from './onboardingHero.module.css';

const HeroOverlay: React.FC = () => <div className={styles.overlay} aria-hidden="true" />;

export default HeroOverlay;
